module.exports = __webpack_public_path__ + "static/media/heroimage_igib-021.57f752ac.jpg";